import { Skeleton as AntSkeleton, Table as AntTable } from 'antd';
import styled from 'styled-components';
import { Panel as PanelAtom } from 'components/atoms/collapse';

export const Panel = styled(PanelAtom)`
  &.ant-collapse-item-active {
    margin-bottom: var(--layout-03);
  }

  margin-bottom: var(--layout-01);
`;

export const Table = styled(AntTable)`
  &&&& .ant-table-cell {
    height: 48px;
    min-width: 200px;
  }

  .ant-table-thead > tr > th,
  .ant-table-thead > tr > th > div {
    padding: var(--spacing-02) var(--spacing-04);
    font-size: var(--font-size-base);
    font-weight: var(--heading-7-weight);
  }

  .ant-table-tbody > tr > td {
    padding: var(--spacing-05) var(--spacing-04);
  }

  .ant-table-thead > tr > th > div > div {
    padding: var(--spacing-05) var(--spacing-02);
  }

  .ant-table-tbody,
  .ant-table-content {
    overflow-x: scroll;
    overflow-y: hidden;
    max-width: 100vw;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .ant-table-content::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .ant-table-content {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  &&&& .ant-table-row:last-child > .ant-table-cell {
    border-bottom: none;
  }

  .ant-table.ant-table-small {
    padding: 0;
  }

  &&&& th.ant-table-cell {
    background: var(--coolest-gray-20);
    height: 32px;
    &:first-child {
      padding-left: var(--spacing-03);
    }
    &.ant-table-column-sort {
      background: var(--coolest-gray-30);
    }
  }

  .ant-table-tbody > .ant-table-placeholder {
    display: none; /* Hide the placeholder container in header */
  }
`;

export const Skeleton = styled(AntSkeleton)`
  padding: var(--spacing-05);
  background-color: var(--white-100);
`;

export const CSATScrollbar = styled.div`
  overflow-x: scroll;
  width: calc(100% - (var(--side-nav-width) + 2 * var(--spacing-05)));
  position: absolute;
  bottom: 0;
  z-index: 100;
`;
